import { Component } from '@angular/core';
import { ControlComponent } from '../base/control.component';
import { LivechartsService } from '../../../../livecharts.service';

@Component({
  selector: 'lib-standard-slide',
  templateUrl: './standard-slide.component.html',
  styleUrls: ['./standard-slide.component.scss'],
})
export class StandardSlideComponent extends ControlComponent {
  constructor(public livechartsService: LivechartsService) {
    super(livechartsService);
  }
}
